enum ActivityStatusOption {
  ALL = "all",
  OVERDUE = "overdue",
  COMPLETED = "complete",
  INCOMPLETE = "incomplete",
  UPCOMING = "upcoming",
  NOT_SCHEDULED = "notScheduled",
}

export default ActivityStatusOption;
